<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  @switch (model.inputType) {
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_PASSWORD) {
      <profile-pds-p-input-password
        p-input-password
        [label]="model.label ?? undefined"
        [description]="descriptionText"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        autocomplete="noi"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [value]="group.get(model.id)?.value ?? ''"
        [id]="id"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="model.pattern ?? ''"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellcheck]="model.spellCheck"
        [tabindex]="model.tabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </profile-pds-p-input-password>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_DATE) {
      <profile-pds-p-input-date
        p-input-date
        [label]="model.label ?? undefined"
        [description]="descriptionText"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        autocomplete="noi"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [value]="group.get(model.id)?.value ?? ''"
        [id]="id"
        [max]="model.maxLength?.toString()"
        [min]="model.minLength?.toString()"
        [name]="model.name"
        [pattern]="model.pattern ?? ''"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellcheck]="model.spellCheck"
        [tabindex]="model.tabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </profile-pds-p-input-date>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_EMAIL) {
      <profile-pds-p-input-email
        p-input-email
        [label]="model.label ?? undefined"
        [description]="descriptionText"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        autocomplete="noi"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [value]="group.get(model.id)?.value ?? ''"
        [id]="id"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="model.pattern ?? ''"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellcheck]="model.spellCheck"
        [tabindex]="model.tabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </profile-pds-p-input-email>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_TEL) {
      <profile-pds-p-input-tel
        p-input-tel
        [label]="model.label ?? undefined"
        [description]="descriptionText"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        autocomplete="noi"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [value]="group.get(model.id)?.value ?? ''"
        [id]="id"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="model.pattern ?? ''"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellcheck]="model.spellCheck"
        [tabindex]="model.tabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </profile-pds-p-input-tel>
    }
    @default {
      <profile-pds-p-input-text
        p-input-text
        [label]="model.label ?? undefined"
        [description]="descriptionText"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        autocomplete="noi"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [value]="group.get(model.id)?.value ?? ''"
        [id]="id"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="model.pattern ?? ''"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellcheck]="model.spellCheck"
        [tabindex]="model.tabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </profile-pds-p-input-text>
    }
  }
</div>
